import React from "react";

import type { Theme } from "@mui/material";

import { numbers } from "@readai/pulse/theme";
import { px } from "@readai/pulse/utils";

declare module "@mui/material/styles" {
  interface Theme {
    corners: {
      round: React.CSSProperties["borderRadius"];
      xlarge: React.CSSProperties["borderRadius"];
      large: React.CSSProperties["borderRadius"];
      base: React.CSSProperties["borderRadius"];
      small: React.CSSProperties["borderRadius"];
      xsmall: React.CSSProperties["borderRadius"];
    };
  }

  interface ThemeOptions {
    corners?: {
      round?: React.CSSProperties["borderRadius"];
      xlarge?: React.CSSProperties["borderRadius"];
      large?: React.CSSProperties["borderRadius"];
      base?: React.CSSProperties["borderRadius"];
      small?: React.CSSProperties["borderRadius"];
      xsmall?: React.CSSProperties["borderRadius"];
    };
  }
}

const corners: Theme["corners"] = {
  round: "50%",
  xlarge: px(numbers.numbers.corner.xlarge),
  large: px(numbers.numbers.corner.large),
  base: px(numbers.numbers.corner.base),
  small: px(numbers.numbers.corner.small),
  xsmall: px(numbers.numbers.corner.xsmall),
};

export default corners;
